import {createAction} from 'typesafe-actions';
import ISystemInfo = MyTypes.ISystemInfo;

export const emptyAction = createAction('@SYS/EMPTY_ACTION')();
export const debugAction = createAction('@SYS/DEBUG_ACTION')<any>();
export const sysSetLoaded = createAction('@SYS/LOADED')<boolean>();
export const sysSetInfo = createAction('@SYS/INFO_CODE')<ISystemInfo>();



// WEBPACK FOOTER //
// ./src/store/system/actions.ts